import React from 'react';
import './TestQueueTag.css';

/**
 * "Test" tag for a queue entry or call that came in through the booth's test link
 * (/queue/<booth>/test/<code>). The word is visible, so the tag never relies on colour;
 * `srContext` adds words for screen readers, e.g. "queue entry" → "Test queue entry".
 */
export default function TestQueueTag({ srContext = '', className = '' }) {
  return (
    <span className={`test-queue-tag ${className}`.trim()}>
      Test
      {srContext ? <span className="sr-only"> {srContext}</span> : null}
    </span>
  );
}
